import React from 'react';
import './ProductCatagories.css';
import { Link } from "react-router-dom";
import Domestic from './img7.jpg'
const ProductCategories = () => {
  return (
    <div className="mainHome-container1">

        <div className="ALLOYMETALS-herosection" >
            <div className="AgroMETALS-herosection-pic" style={{width:"100%"}}>
                <div className="ALLOYMETALS-herosection-heading " >
                    HOME / Agro Products Export
                </div>
            
            </div>
            
        </div>
        <div className="Each-Product-container" >
        

            <div className="Each-Product-mid-left-container">
                <div className='Each-Product-tittle'>
                Agro Products Export
                </div>
                <div className='Each-Product-mid-details'>
                Our ferrous metal scrap products, containing iron and magnetic properties, are ideal for construction, manufacturing, and infrastructure projects. These materials ensure durability, versatility, and sustainability, supporting various industrial applications while promoting eco-friendly practices through efficient recycling and resource utilization.
                </div>
            </div>
            <div className="Each-Product-mid-right-container">
                <div className="tranding-pics">
                    <img src={Domestic} alt="" className='tranding-left-pics' />
                </div>

            </div>
        </div>
    <section className="Each-Product-Details-card" style={{height:"auto", paddingBottom:"50px"}}>
      <h2>Agro Products</h2>
      
      <section className="product-categories-list">
      <div className="product-categories-list-header">
        
      </div>

      <div className="product-categories-list-grid">
        {productCategoryDetails.map((productCategory, index) => (
          <div key={index} className="product-categories-list-box">
            <div className="Each-product-benifitt-icon"><img src={productCategory.image} alt={productCategory.image} className='Each-Product-Details-card-img'/></div>
            <h3>{productCategory.title}</h3>
            <p>{productCategory.description}</p>
          </div>
        ))}
      </div>
    </section>
      {/* <button className="view-button">View All Products</button> */}
      {/* <h2 className='Product-category-title'>Browse by Category</h2> */}
    </section>
    
    </div>
  );
};

export default ProductCategories;

const productCategoryDetails = [
    {
      title: "Grains & Cereals",
      description: "We supply high-quality wheat, rice, maize, and barley, sourced from trusted farms to ensure rich nutrition and premium quality.",
      image: "/Products/Agro/1.webp"
    },
    {
      title: "Pulses & Lentils",
      description: "Our pulses include chickpeas, lentils, black beans, and green peas, rich in protein and essential for a healthy diet.",
      image: "/Products/Agro/2.avif"
    },
    {
      title: "Fruits & Vegetables",
      description: "Fresh fruits like mangoes, bananas, apples, and seasonal vegetables are sourced from organic farms for superior taste and nutrition.",
      image: "/Products/Agro/3.webp"
    },
    {
      title: "Dairy Products",
      description: "We provide fresh dairy products including milk, cheese, butter, and yogurt, ensuring high quality and freshness.",
      image: "/Products/Agro/4.jpg"
    },
    {
      title: "Organic Products",
      description: "Our organic range includes naturally grown grains, spices, and herbal products free from chemicals and pesticides.",
      image: "/Products/Agro/5.jpg"
    },

    
  ];
  